'use client';

import { useState } from 'react';
import { signOut } from 'next-auth/react';

import { ConfirmDialog } from '@/components/dashboard/ConfirmDialog';

export function LogoutModal({ open, onClose }: { open: boolean; onClose: () => void }) {
  const [pending, setPending] = useState(false);
  const [error, setError] = useState<string | null>(null);

  return (
    <ConfirmDialog
      open={open}
      title="Sign out of fleetava?"
      description="This clears the staff session on this browser."
      confirmLabel="Sign out"
      cancelLabel="Stay signed in"
      pendingLabel="Signing out…"
      pending={pending}
      error={error}
      onCancel={() => {
        if (pending) return;
        setError(null);
        onClose();
      }}
      onConfirm={async () => {
        setPending(true);
        setError(null);
        try {
          await signOut({ redirect: false });
          window.location.replace('/login');
        } catch {
          setPending(false);
          setError('Could not sign out. Try again.');
        }
      }}
    />
  );
}
